import { Injectable } from '@angular/core';
const mapboxgl = require('../../../../node_modules/mapbox-gl/dist/mapbox-gl.js');
const Map = mapboxgl.Map;

@Injectable()
export class MapService {
  map: Map<any, any>;

  constructor() {
    (mapboxgl as any).accessToken = 'pk.eyJ1IjoidXNlYmVuY2htYXJrIiwiYSI6ImNpd3o4ZzRlcjAwa2kyenFobzV6ODZ3ZWsifQ.c5aNRfsFgOopeSF8LBFGbw';
  }

}



// WEBPACK FOOTER //
// ./src/app/api/resources/map.service.ts